module.exports = __webpack_public_path__ + "img/profile.08189b14.jpg";